import axios from "axios";
import endpoint from "../../index.routes";

const getConfigDetails = async () => {
  const response = await axios.get(endpoint.CONFIG);
  return response.data;
};

const updateConfigDetail = async (params) => {
  const { id, body } = params;
  const response = await axios.put(endpoint.CONFIG+"/"+id, body);
  return response.data;
};

const configServices = { getConfigDetails, updateConfigDetail };

export default configServices;
